import courses from './courses'
import modules from './modules'
import lessons from './lessons'
import quizzes from './quizzes'

export  {courses, modules, lessons, quizzes}